import GameConfig from "../model/GameConfig";

export default class GameElementSkinFactory {
    
    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} gameAssets 
     */
    constructor(gameConfig, gameAssets) {
        this._gameConfig = gameConfig;
        this._gameAssets = gameAssets;
    }

    getItem(index) {
        const skinName = this._gameConfig.getItemSkin(index);
        return new this._gameAssets[skinName];
    }

    getBoxForItemCount(n) {
        const skinName = this._gameConfig.getBoxSkin(n);
        return new this._gameAssets[skinName];
    }

    getBox(id) {
        const skinName = this._gameConfig.getBoxSkin(id);
        return new this._gameAssets[skinName];
    }

}
